import React, { useEffect, useState } from "react";
import { Button, Fade } from "reactstrap";
import axios from "../../../services/axios";
import swal from "sweetalert";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Steps } from "antd";
import { message } from "antd";
import locations from "../../../utils/api/locations";
import ReactLoading from "react-loading";

function ContactCreator({ loadContacts,tab }) {
  const history = useHistory();
  const success = (e) => {
    if (e === "submit") {
      message.success("Submitted Successfully", 2);
    } else if (e === "duplicate") {
      message.error("Mobile or email already exist", 2);
    }
  };
  // States
  const [count, setCount] = useState(1);
  const [contactSources, setContactSources] = useState([]);

  const [locationValue, setLocationValue] = useState("");
  const [nameError, setNameError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [sourceError, setSourceError] = useState("");
  const [locationError, setLocationError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [disableButton, setDisableButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [preferredLocation, setPreferredLocation] = useState([]);
  const [currentLocation, setCurrentLocation] = useState("");
  const { id } = useParams();

  const handleCurrentLocation = (e) => {
    setCurrentLocation(e.target.value);
  };

  const handleLocation = (e) => {
    setLocationValue(e.target.value);
    if(e.target.value !== ''){
      setLocationError("")
    }else{
      setLocationError("Location is required field.")
    }
  };

  const [sourceValue, setSourceValue] = useState("");

  const handleSource = (e) => {
    setSourceValue(e.target.value);
    if(e.target.value !== ''){
      setSourceError("")
    }else{
      setSourceError("Source is required field.")
    }
  };

  const [name, setName] = useState("");
  const handleName = (e) => {
    setName(e.target.value);
    const alphabets = /^[-a-zA-Z][-a-zA-Z ]*$/;
    if (!e.target.value.match(alphabets)) {
      setNameError("Only alphabets are allowed");
    } else if (e.target.value.name === "") {
      setNameError("Name cant't be empty");
    } else {
      setNameError("");
    }
  };

  const [email, setEmail] = useState("");
  const handleEmail = (e) => {
    setEmail(e.target.value);
    const emailValidate = /\S+@\S+\.\S+/;
    if (e.target.value === "") {
      setEmailError("");
    } else if (!e.target.value.match(emailValidate)) {
      setEmailError("Invalid email format.");
    } else {
      setEmailError("");
    }
  };

  function mobileNumber(Number) {
    var regexExp = /^[6-9]\d{9}$/gi;
    if (regexExp.test(Number)) {
      return true;
    } else {
      return false;
    }
  }

  const [phone, setPhone] = useState("");
  const handlePhone = (e) => {
    setPhone(e.target.value);
    let isnum = /^\d+$/;
    if (!isnum.test(e.target.value)) {
      setPhoneError("Only numbers are allowed");
    } else if (e.target.value.length !== 10) {
      setPhoneError("Mobile Number should be of 10 digits");
    } else if (mobileNumber(e.target.value) === false) {
      setPhoneError("Invalid Mobile Number");
    } else {
      setPhoneError("");
    }
  };
  const [formName, setFormName] = useState([]);
  const [formId, setFormId] = useState("");
  const [formError, setFormError] = useState("");
  // Effects and Events
  useEffect(() => {
    (async () => {
      const { data } = await axios.get("/formtemplate/SourceName", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      });
      setContactSources(data.filter(source => !['employee reference','maxicus website','consultant'].includes(source?.trim()?.toLowerCase())));
    })();

    axios
      .get("/formtemplate", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      })
      .then((res) => {
        const data = res.data;
        setFormName(data);
      });

    locations().then((res) => {
      setPreferredLocation(res);
    });
  }, []);

  const handleSelectFormType = (e) => {
    setFormId(e.target.value);
    if (e.target.value === "") {
      setFormError("Form Type is required");
    } else {
      setFormError("");
    }
  };

  function refresh() {
    window.location.reload(true);
  }

  useEffect(() => {
    if(name ==='' || phone === '' || sourceValue === '' || locationValue === ''){
      setDisableButton(true)
    }else{
      setDisableButton(false)
    }
  },[name,email,phone,sourceValue,locationValue])

  function onClickSendToAll(e) {
    let contacts = {
      name: name,
      email: email,
      phone: phone,
      source: sourceValue,
      location: locationValue,
      currentLocation: currentLocation,
      current_location: currentLocation,
      createdBy: localStorage.getItem("user.id"),
    };

    if (formId !== "") {
      if (
        formError === "" &&
        nameError === "" &&
        name !== "" &&
        phoneError === "" &&
        phone !== "" &&
        emailError === "" &&
        (email === "" || email !== "")
      ) {
        setLoading(true)
        axios
          .post("contacts/" + formId, contacts, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("user.token")}`,
            },
          })
          .then((res) => {
            setEmailError("");
            // loadContacts();
            if (res.data.errorMessage) {
              success("duplicate");
            } else {
              setTimeout(() => {
                history.push(`/candidate/${res.data._id}?tab=${tab}`);
              }, 1000);
              success("submit");
            }
          })
          .catch((err) => {
            message.warning(err.response.data.error);
          }).finally(() => {
            setLoading(false)
          })
      }
    } else {
      setFormError("Form Type is required");
    }
  }

  return (
    <>
      {
        loading && <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      }
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="row">
            <div className="col-md-4">
              <label>Application Type</label><span style={{ color: "red" }}>*</span>
              <select
                id="FormType"
                className="form-control"
                onChange={handleSelectFormType}
                // value={formId}
              >
                <option value="" selected="true">
                Application Type
                </option>
                {formName &&
                  formName
                    .map((obj) => {
                      if (obj.formType && obj.formType === "Joining_Form") {
                        return (
                          <option key={obj?._id} value={obj?._id}>
                            {obj?.name?.trim()}
                          </option>
                        );
                      }
                    })}
              </select>
              {formError && (
                <div className="text-danger mb-1">
                  {formError}
                </div>
              )}
            </div>
            <div className="col-md-4">
              <label>Name</label><span style={{ color: "red" }}>*</span>
              <input
                className="form-control contact-name"
                name="name"
                type="text"
                value={name}
                onChange={handleName}
              />
              {nameError && (
                <div className="text-danger">
                  {nameError}
                </div>
              )}
            </div>
            <div className="col-md-4">
              <label>Email</label>
              <input
                className="form-control contact-email"
                name="email"
                type="email"
                value={email}
                onChange={handleEmail}
              />
              {emailError && (
                <div className="text-danger">
                  {emailError}
                </div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label>Phone</label><span style={{ color: "red" }}>*</span>
              <input
                className="form-control contact-phone"
                name="phone"
                type="text"
                maxLength={10}
                value={phone}
                onChange={handlePhone}
              />
              {phoneError && (
                <div className="text-danger">
                  {phoneError}
                </div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label>Source</label><span style={{ color: "red" }}>*</span>
              <select
                onChange={handleSource}
                className="form-control contact-source"
                name="source"
                value={sourceValue}
              >
                <option selected value="">
                  Select Source
                </option>
                {contactSources.map((source) => (
                  <option value={source}>{source}</option>
                ))}
              </select>
              {sourceError && (
                <div className="text-danger">
                  {sourceError}
                </div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label>Location</label><span style={{ color: "red" }}>*</span>
              <select
                onChange={handleLocation}
                className="form-control contact-location"
                name="location"
                value={locationValue}
              >
                <option selected value="">
                  Select Location
                </option>
                {preferredLocation?.map((ele) => (
                  <option value={ele?.locationName}>{ele?.locationName}</option>
                ))}
              </select>
              {locationError && (
                <div className="text-danger">
                  {locationError}
                </div>
              )}
            </div>
            <div className="col-md-4 mt-4">
              <label>Current Location</label>
              <input
                className="form-control contact-current-location"
                name="currentLocation"
                type="text"
                placeholder="Enter Current Location"
                value={currentLocation}
                onChange={handleCurrentLocation}
              />
            </div>
            <div className={`col-md-12 d-flex align-items-center justify-content-center mt-4`}>
              <Button
                disabled={disableButton}
                color= { disableButton ? "secondary" :"primary"}
                onClick={onClickSendToAll}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>

        {/* <Button
          className="ml-1"
          color="danger"
          onClick={(e) => {
            setCount(0);
            setTimeout(() => {
              setCount(0);
            }, 10);
          }}
        >
          Clear
        </Button> */}
      </div>
    </>
  );
}

export default ContactCreator;
